import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import {
  Card,
  Divider,
  Icon,
  Label,
  Loader,
  Segment,
  Radio,
  Grid,
  GridColumn,
} from 'semantic-ui-react';

import { compose } from 'recompose';

import TargetLink from '../../components/target-link';
import hasRESTClient from '../../hocs/has-rest-client';

const labelStyle = {
  cursor: 'pointer',
  margin: 5,
};

const titleStyle = {
  display: 'block',
  float: 'left',
};

const resetLinkStyle = {
  display: 'block',
  fontSize: 14,
  float: 'right',
  color: 'rgb(32, 196, 158)',
};

class OrganisationTags extends React.Component {
  //
  constructor(props) {
    super(props);
    const { mustMatchAllTags } = props;
    this.state = {
      isLoading: true,
      failedToLoadTags: false,
      mustMatchAllTags,
      tags: [],
    };
  }

  async componentDidMount() {
    const { restClient, organisationId } = this.props;
    const response = await restClient.get(`tags?filter[organisation]=${organisationId}`).catch(error => {
      this.setState({
        isLoading: false,
        failedToLoadTags: false,
        tags: [],
      });
    });
    if (!response) {
      this.setState({
        isLoading: false,
      });
      return;
    }
    const tags = _.get(response, 'data.data', []);
    this.setState({
      tags,
      isLoading: false,
      failedToLoadTags: false,
    });
  }

  onToggle = () => {
    const { onSwitchToggle } = this.props;
    this.setState(prev => ({
      mustMatchAllTags: !prev.mustMatchAllTags,
    }), () => {
      onSwitchToggle(this.state.mustMatchAllTags);
    });
  }
  render() {
    const { isLoading, tags, mustMatchAllTags } = this.state;
    const { onTagSelected, selectedTags } = this.props;
    const isSelected = id => _.some(selectedTags, tg => _.eq(tg, id));
    const canSelect = id => _.size(selectedTags) < 10 || isSelected(id);
    const tagStyles = id => (canSelect(id) ? labelStyle : { ...labelStyle, cursor: 'not-allowed' });
    return (
      <Card fluid color="blue" >
        <Card.Content>
          <Card.Header>
            <span style={titleStyle}>Tag Search</span>
            <a onClick={() => onTagSelected(null)} style={resetLinkStyle}>Clear filter <Icon name="x" /></a>
            <Divider clearing fitted hidden />
          </Card.Header>
          <Card.Meta>
            <br />This will search influencers tags directly.
            <br /><i>NOT</i> their handles, description or bios.
            <Divider />
            <p>The tag search will bring back <i>all</i> matching influencers. You can <TargetLink target="_self" renderIf href="/team/tags">manage tags here</TargetLink>.</p>
          </Card.Meta>
        </Card.Content>

        <Card.Content>
          <Grid>
            <GridColumn width={12}>
              <span>Must match all selected tags</span>
            </GridColumn>
            <GridColumn width={4}>
              <Radio
                toggle
                checked={mustMatchAllTags}
                onChange={this.onToggle}
              />

            </GridColumn>
          </Grid>
        </Card.Content>
        <Card.Content textAlign="center">
          {
            isLoading && (
              <Segment>
                <Loader active content="Loading tags" />
              </Segment>
            )
          }
          <div>
            {
              !isLoading && _.map(tags, tag =>
                <Label
                  basic={!isSelected(_.get(tag, 'id'))}
                  inverted
                  onClick={() => (canSelect(_.get(tag, 'id')) ? onTagSelected(_.get(tag, 'id'), mustMatchAllTags) : _.noop())}
                  style={tagStyles(_.get(tag, 'id'))}
                  color={isSelected(_.get(tag, 'id')) ? 'pink' : null}
                  key={_.get(tag, 'id')}
                >{_.get(tag, 'attributes.value')}</Label>,
              )
            }
          </div>

        </Card.Content>
      </Card>
    );
  }
}

OrganisationTags.propTypes = {
  onTagSelected: PropTypes.func.isRequired,
  organisationId: PropTypes.string.isRequired,
  selectedTags: PropTypes.array,
  onSwitchToggle: PropTypes.func,
  mustMatchAllTags: PropTypes.bool,
};

OrganisationTags.defaultProps = {
  selectedTags: [],
  onSwitchToggle: _.noop,
  mustMatchAllTags: true,
};

export default compose(
  hasRESTClient,
)(OrganisationTags);



/** WEBPACK FOOTER **
 ** ./src/components/organisation-tags/index.js
 **/